import React, { useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { useOnClickOutside } from '_hooks'

const TOP = 'top'
const BOTTOM = 'bottom'
const LEFT = 'left'

const Popup = ({ children, position = 'bottom right', height = '100%', onClose }, ref) => {
  const popupRef = useRef()
  const [isOpen, setIsOpen] = useState(false)
  const [triggerRef, setTriggerRef] = useState()

  const positionSplit = position.split(' ')
  const vPosition = positionSplit[0]
  const hPosition = positionSplit[1]

  const open = () => {
    setIsOpen(true)
  }

  const close = () => {
    setIsOpen(false)
    onClose?.()
  }

  useOnClickOutside(popupRef, close)

  if (!ref.current) {
    ref.current = { isOpen, open, close, setTriggerRef }
  }

  const left =
    (triggerRef?.getBoundingClientRect().left || 0) -
    (hPosition === LEFT ? popupRef?.current?.scrollWidth || 0 : 0)
  const top = Math.max(
    0,
    (triggerRef?.getBoundingClientRect().top || 0) -
      (vPosition === TOP ? popupRef?.current?.scrollHeight || 0 : 0)
  )
  const bottom = window.innerHeight - (triggerRef?.getBoundingClientRect().top || 0)

  return createPortal(
    <div
      ref={popupRef}
      style={{
        opacity: isOpen ? 1 : 0,
        pointerEvents: isOpen ? 'all' : 'none',
        position: 'fixed',
        left,
        top: vPosition === BOTTOM ? top : undefined,
        bottom: vPosition === TOP ? bottom : undefined,
        zIndex: 999999,
        maxWidth: `calc(100vw - ${left}px)`,
        maxHeight: `calc(100vh - ${top}px)`,
        // boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.16), 2px 1px 20px rgba(0, 0, 0, 0.08)',
        borderRadius: 4,
        height,
      }}
    >
      {children}
    </div>,
    document.body
  )
}

export default React.forwardRef(Popup)
